import axios from "axios";
import { Component } from "react";
import { Button, Card, Col, Form, Row } from "react-bootstrap";
import CommonToast from "./Toaster/CommonToast";
import CommonLoader from "./loaderComponent/CommonLoader";

export default class DeliveryChallanAdd extends Component {
  constructor(props) {
    super(props);
    this.state = {
      customers: [],
      projects: [],
      purchaseOrders: [],
      poItems: [],
      dcNumber: "",
      dcDate: "",
      customerId: "",
      projectId: "",
      purchaseOrderId: "",
      status: "",
      loading: true,
      showToast: false,
      toastMessage: "",
      toastVariant: "",
      color: '',
      errors: {},
      isEdit: false,
      dcId: null,
    };
  }

  componentDidMount() {
    this.fetchCustomers();
    const dcId = this.props.match?.params?.id;
    console.log("dcId", dcId)
    if (dcId) {
      this.setState({ isEdit: true, dcId });
      this.fetchDeliveryChallan(dcId);
    }
  }

  handleRemarkChange = (index, value) => {
    this.setState(prevState => {
      const updatedItems = [...prevState.poItems];

      updatedItems[index] = {
        ...updatedItems[index],
        remark: value
      };

      return { poItems: updatedItems };
    });
  };

  fetchCustomers = () => {
    axios
      .get("/customer")
      .then((res) => {
        this.setState({ customers: res.data, loading: false });
      })
      .catch(() => {
        setTimeout(() => {
          this.setState({ loading: false });
        }, 900);
      });
  };

  fetchProjects = (customerId) => {
    axios
      .get(`/project/customer/${customerId}`)
      .then((res) => {
        this.setState({ projects: res.data, loading: false });
      })
      .catch(() => {
        setTimeout(() => {
          this.setState({ loading: false });
        }, 900);
      });
  };

  fetchPurchaseOrders = (customerId, projectId) => {
    axios
      .get(`/purchaseOrders/${customerId}/${projectId}`)
      .then((res) => {
        this.setState({
          purchaseOrders: res.data,
          loading: false
        });
      })
      .catch(() => {
        setTimeout(() => {
          this.setState({ loading: false });
        }, 900);
      });
  };

  fetchPoItems = (purchaseOrderId) => {
    // debugger;
    this.setState({ loading: true });
    axios
      .get(`/purchaseOrders/${purchaseOrderId}`)
      .then((res) => {
        console.log("res.data.items", res.data.items)
        this.setState({
          poItems: res.data.items.map((item) => ({
            purchaseOrderItemId: item.id,
            itemName: item.item.name,
            askedQuantity: item.quantity,
            serialNumber: item.serialNumber,
            pendingQuantity: item.pendingQuantity,
            uom: item.uom,
            remark: item.remark,
            quantity: 0,
            loading: false
          })),
        });
        setTimeout(() => {
          this.setState({ loading: false });
        }, 900);
      })
      .catch(() => {
        setTimeout(() => {
          this.setState({ loading: false });
        }, 900);
      });
  };

  fetchDeliveryChallan = (id) => {
    axios
      .get(`/deliveryChallans/${id}`)
      .then((res) => {
        const dc = res.data;
        console.log(" dc.items", dc.items)
        this.setState({
          dcNumber: dc.dcNumber,
          dcDate: dc.dcDate,
          customerId: dc.customerId,
          projectId: dc.projectId,
          purchaseOrderId: dc.purchaseOrderId,
          status: dc.status,
          poItems: dc.items.map((item) => ({
            purchaseOrderItemId: item.purchaseOrderItemId,
            //itemName: item.purchaseOrderItem?.itemId,
            itemName: item.purchaseOrderItem?.item?.name,
            askedQuantity: item.purchaseOrderItem.quantity,
            pendingQuantity: item.purchaseOrderItem.pendingQuantity,
            serialNumber: item.purchaseOrderItem.serialNumber,
            uom: item.uom,
            remark: item.remark,
            quantity: item.quantity,
          })),
        }, () => {
          // These will run after state is updated
          this.fetchProjects(dc.customerId);
          this.fetchPurchaseOrders(dc.customerId, dc.projectId);
          setTimeout(() => {
            this.setState({ loading: false });
          }, 900);
        });
      })
      .catch((err) => {
        console.error("Error fetching delivery challan:", err);
        this.setState({
          showToast: true,
          toastMessage: "Failed to load delivery challan data",
          toastVariant: "danger",
          color: 'red'
        });
        setTimeout(() => {
          this.setState({ loading: false });
        }, 900);
      });
  };

  handleCustomerChange = (e) => {
    const customerId = e.target.value;
    this.setState(
      {
        customerId,
        projectId: "",
        purchaseOrderId: "",
        projects: [],
        purchaseOrders: [],
        poItems: [],
      },
      () => {
        if (customerId) {
          this.fetchProjects(customerId);
        }
      }
    );
  };

  handleProjectChange = (e) => {
    const projectId = e.target.value;
    this.setState(
      {
        projectId,
        purchaseOrderId: "",
        purchaseOrders: [],
        poItems: [],
      },
      () => {
        if (this.state.customerId && projectId) {
          this.fetchPurchaseOrders(this.state.customerId, projectId);
        }
      }
    );
  };

  handlePurchaseOrderChange = (e) => {
    const purchaseOrderId = e.target.value;
    this.setState({ purchaseOrderId, poItems: [] }, () => {
      if (purchaseOrderId) {
        this.fetchPoItems(purchaseOrderId);
      }
    });
  };

  handlePoItemQuantityChange = (index, value) => {
    // debugger
    const poItems = [...this.state.poItems];
    if (value === '') {
      poItems[index].quantity = '';
      this.setState({ poItems });
      return;
    }
    const quantity = parseFloat(value);
    if (isNaN(quantity)) return;
    if (quantity < 0) return;

    if (quantity > poItems[index].pendingQuantity) {
      this.setState({
        showToast: true,
        toastMessage: "Quantity cannot be more than pending quantity",
        toastVariant: "danger",
        color: 'red'
      });
      return;
    }

    poItems[index].quantity = quantity;
    this.setState({ poItems });
  };

  validateForm = () => {
    const errors = {};
    if (!this.state.customerId) errors.customerId = "Customer is required";
    if (!this.state.projectId) errors.projectId = "Project is required";
    if (!this.state.purchaseOrderId) errors.purchaseOrderId = "Purchase Order is required";
    // if (!this.state.dcNumber.trim()) errors.dcNumber = "DC Number is required";

    const dcNumber = this.state.dcNumber.trim();
    const dcNumberRegex = /^[a-zA-Z0-9!@#$%^&*()_+\-=[\]{};':"\\|,.<>/?`~ ]{1,30}$/;

    if (!dcNumber) {
      errors.dcNumber = "DC Number is required";
    } else if (!dcNumberRegex.test(dcNumber)) {
      errors.dcNumber = "DC Number must be be 1 to 30 characters and can include letters, numbers, and special characters";
    }
    if (!this.state.dcDate) errors.dcDate = "DC Date is required";
    this.state.poItems.forEach((item, index) => {
      //if (item.quantity <= 0) errors[`quantity_${index}`] = "Quantity must be greater than 0";
      if (item.quantity > item.pendingQuantity) errors[`quantity_${index}`] = "Quantity cannot exceed pending quantity";
    });
    return errors;
  };

  handleSubmit = (status) => {
    const errors = this.validateForm();
    if (Object.keys(errors).length > 0) {
      this.setState({
        errors,
        showToast: true,
        toastMessage: "Please fix validation errors",
        toastVariant: "danger",
        color: 'red'
      });
      return;
    }

    this.setState({ loading: true });

    const {
      customerId,
      projectId,
      purchaseOrderId,
      dcNumber,
      dcDate,
      poItems,
      isEdit,
      dcId,
    } = this.state;

    const payload = {
      customerId,
      projectId,
      purchaseOrderId,
      dcNumber,
      dcDate,
      status,  // dynamic status passed here
      items: poItems,
    };

    const request = isEdit
      ? axios.put(`/deliveryChallans/${dcId}`, payload)
      : axios.post("/deliveryChallans", payload);

    request
      .then(() => {
        this.setState({
          showToast: true,
          toastMessage: `Delivery Challan ${isEdit ? "updated" : "created"} successfully!`,
          toastVariant: "success",
          color: 'green'
        });

        if (!isEdit) {
          this.setState({
            customerId: "",
            projectId: "",
            purchaseOrderId: "",
            dcNumber: "",
            dcDate: "",
            poItems: [],
            errors: {},
          });
        }
        setTimeout(() => {
          this.setState({ loading: false })
          this.handleBack()
        }, 600)
      })
      .catch((error) => {
        this.setState({
          loading: false,
          showToast: true,
          toastMessage: error.response?.data?.message || "Error saving Delivery Challan",
          toastVariant: "danger",
          color: 'red'
        });
      });
  };


  handleBack = () => {
    this.setState({ loading: true });
    setTimeout(() => {
      this.props.history.push("/DeliveryChallanList");
      this.setState({ loading: false });
    }, 500);
  }

  render() {
    const {
      customers,
      projects,
      purchaseOrders,
      poItems,
      dcNumber,
      dcDate,
      customerId,
      projectId,
      purchaseOrderId,
      status,
      errors,
      loading,
      isEdit,
    } = this.state;

    return (
      <>
        <CommonToast
          show={this.state.showToast}
          onClose={() => this.setState({ showToast: false })}
          message={this.state.toastMessage}
          variant={this.state.toastVariant}
          color={this.state.color}
        />
        <CommonLoader isLoading={loading}>
          <div className="container-fluid pt-4">
            <Card>
              <Card.Header>
                <div className="purchase-order-back">
                  <b>{isEdit ? "Update" : "Add"} Delivery Challan</b>
                  <span style={{ cursor: 'pointer' }} onClick={() => this.handleBack()}>
                    <i className="far fa-arrow-alt-circle-right"> Delivery Challan List</i>
                  </span>
                </div>
              </Card.Header>
              <Card.Body style={{ marginBottom: '40px' }}>
                <Form onSubmit={this.onSubmit}>
                  <Row>
                    <Col md={3}>
                      <Form.Group controlId="formCustomer">
                        <Form.Label className="required">Customer</Form.Label>
                        <Form.Control
                          as="select"
                          className="form-select"
                          value={customerId}
                          onChange={this.handleCustomerChange}
                          isInvalid={!!errors?.customerId}
                          disabled={status === "Invoice" || status === "paid"}
                        >
                          <option value="">Select Customer</option>
                          {customers.map((c) => (
                            <option key={c.id} value={c.id}>
                              {c.name}
                            </option>
                          ))}
                        </Form.Control>
                        <Form.Control.Feedback type="invalid">{errors?.customerId}</Form.Control.Feedback>
                      </Form.Group>
                    </Col>
                    <Col md={3}>
                      <Form.Group controlId="formProject">
                        <Form.Label className="required">Project</Form.Label>
                        <Form.Control
                          as="select"
                          className="form-select"
                          value={projectId}
                          onChange={this.handleProjectChange}
                          isInvalid={!!errors?.projectId}
                          disabled={status === "Invoice" || status === "paid"}
                        >
                          <option value="">Select Project</option>
                          {projects.map((p) => (
                            <option key={p.id} value={p.id}>
                              {p.name}
                            </option>
                          ))}
                        </Form.Control>
                        <Form.Control.Feedback type="invalid">{errors?.projectId}</Form.Control.Feedback>
                      </Form.Group>
                    </Col>
                    <Col md={2}>
                      <Form.Group controlId="formPurchaseOrder">
                        <Form.Label className="required">Purchase Order</Form.Label>
                        <Form.Control
                          as="select"
                          className="form-select"
                          value={purchaseOrderId}
                          onChange={this.handlePurchaseOrderChange}
                          isInvalid={!!errors?.purchaseOrderId}
                          disabled={status === "Invoice" || status === "paid"}
                        >
                          <option value="">Select PO NO.</option>
                          {purchaseOrders.map((po) => (
                            <option key={po.id} value={po.id}>
                              {po.poNumber}
                            </option>
                          ))}
                        </Form.Control>
                        <Form.Control.Feedback type="invalid">{errors?.purchaseOrderId}</Form.Control.Feedback>
                      </Form.Group>
                    </Col>
                    <Col md={2}>
                      <Form.Group controlId="formDcNumber">
                        <Form.Label className="required">DC Number</Form.Label>
                        <Form.Control
                          type="text"
                          placeholder="DC Number"
                          value={dcNumber}
                          onChange={(e) => this.setState({ dcNumber: e.target.value })}
                          isInvalid={!!errors?.dcNumber}
                          disabled={status === "Invoice" || status === "paid"}
                        />
                        <Form.Control.Feedback type="invalid">{errors?.dcNumber}</Form.Control.Feedback>
                      </Form.Group>
                    </Col>
                    <Col md={2}>
                      <Form.Group controlId="formDcDate">
                        <Form.Label className="required">DC Date</Form.Label>
                        <Form.Control
                          type="date"
                          value={dcDate}
                          onChange={(e) => this.setState({ dcDate: e.target.value })}
                          isInvalid={!!errors?.dcDate}
                          disabled={status === "Invoice" || status === "paid"}
                        />
                        <Form.Control.Feedback type="invalid">{errors?.dcDate}</Form.Control.Feedback>
                      </Form.Group>
                    </Col>
                  </Row>
                  <hr />
                  <h5>Items</h5>
                  {poItems.map((item, index) => (
                    <Card key={index} className="mb-3">
                      {/* {console.log("hello item", item)} */}
                      <Card.Body>
                        <Row>
                          <Col md={1}>
                            <Form.Group controlId={`formItemName${index}`}>
                              <Form.Label>S.No</Form.Label>
                              <Form.Control type="text" value={item.serialNumber || 'hello'} readOnly />
                            </Form.Group>
                          </Col>
                          <Col md={2}>
                            <Form.Group controlId={`formItemName${index}`}>
                              <Form.Label>Item</Form.Label>
                              <Form.Control type="text" value={item.itemName} readOnly />
                            </Form.Group>
                          </Col>
                          <Col md={2}>
                            <Form.Group controlId={`formAskedQuantity${index}`}>
                              <Form.Label>PO Quantity</Form.Label>
                              <Form.Control type="number" value={item.askedQuantity} readOnly />
                            </Form.Group>
                          </Col>
                          <Col md={2}>
                            <Form.Group controlId={`formPendingQuantity${index}`}>
                              <Form.Label>Balance Quantity</Form.Label>
                              <Form.Control type="number" value={item.pendingQuantity} readOnly />
                            </Form.Group>
                          </Col>
                          <Col md={1}>
                            <Form.Group controlId={`formUom${index}`}>
                              <Form.Label>UOM</Form.Label>
                              <Form.Control type="text" value={item.uom} readOnly />
                            </Form.Group>
                          </Col>
                          <Col md={2}>
                            <Form.Group controlId={`formQuantity${index}`}>
                              <Form.Label className="required">Ask Quantity</Form.Label>
                              <Form.Control
                                type="number"
                                value={item.quantity}
                                onChange={(e) => this.handlePoItemQuantityChange(index, e.target.value)}
                                isInvalid={!!errors?.[`quantity_${index}`]}
                                disabled={status === "invoiced" || status === "paid"}
                              />
                              <Form.Control.Feedback type="invalid">{errors?.[`quantity_${index}`]}</Form.Control.Feedback>
                            </Form.Group>
                          </Col>
                          <Col md={2}>
                            <Form.Group controlId={`formRemark${index}`}>
                              <Form.Label>Remark</Form.Label>
                              <Form.Control
                                as="textarea"
                                rows={1}
                                value={item.remark || ""}
                                onChange={(e) => this.handleRemarkChange(index, e.target.value)}
                              />
                            </Form.Group>
                          </Col>
                        </Row>
                      </Card.Body>
                    </Card>
                  ))}
                  {/* <div className='add-cancel-btn '>
                    {status !== "invoiced" && status !== "paid" && (
                      <Button variant="primary" type="submit" className="mt-2">
                        {this.props.match?.params?.id ? "Update Delivery Challan" : "Save Delivery Challan"}
                      </Button>
                    )}
                    <Button variant="outline-danger" className="mt-2" onClick={this.handleBack}>Cancel</Button>
                  </div> */}
                  <div className="text-left mt-3">
                    <span className="status-btn">
                      <Button
                        variant='primary' className=" px-4 py-2 rounded-pill shadow-sm custom-add-button btn btn-primary"
                        onClick={() => this.handleSubmit("Draft")}
                        disabled={status === "invoiced" || status === "paid"}
                      >
                        Save Draft
                      </Button>
                    </span>
                    <Button
                      variant='warning' className="px-4 py-2 rounded-pill shadow-sm custom-add-button-generate btn btn-primary status-btn"
                      onClick={() => this.handleSubmit("Pending")}
                      disabled={status === "invoiced" || status === "paid"}
                    >
                      Generate DC
                      {/* Save as Pending */}
                    </Button>
                    <Button
                      variant='danger' className=" px-4 py-2 rounded-pill shadow-sm custom-add-button-cancel"
                      onClick={() => this.handleBack()}
                    >
                      Cancel
                      {/* Save as Pending */}
                    </Button>
                  </div>

                </Form>
              </Card.Body>
            </Card>
          </div>
        </CommonLoader >
      </>
    );
  }
}
